  import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalibrationRequestToStatusService {

  constructor(private http: HttpClient) { }


  SubmitCalibrationStatus(Token: String,
    id:number,
    dsc:string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/SubmitCalibrationStatus?token=" + Token
      + "&id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetCalibrationStatus(Token: String,id:number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetCalibrationStatus?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

}
